import type { ReactNode } from 'react';

import { Card } from '@/app/components/ui/Card';

/**
 * Full-page stand-in shown while the app cannot render its normal shell:
 * redirecting to Keycloak, processing the callback, or a failed sign-in.
 * White page with centered Card (max-w-sm).
 */
export function AuthScreen({ title, children }: { title: string; children?: ReactNode }) {
  return (
    <div className="bg-paper flex min-h-screen items-center justify-center p-4">
      <Card className="flex w-full max-w-sm flex-col items-center gap-4">
        <p className="text-accent text-sm">NOLATR</p>
        <h1 className="text-ink text-center text-xl font-semibold">{title}</h1>
        <div role="status">{children}</div>
      </Card>
    </div>
  );
}
